import script from "./widgetList.vue?vue&type=script&lang=js"
export * from "./widgetList.vue?vue&type=script&lang=js"

import "./widgetList.vue?vue&type=style&index=0&id=d30d7d1c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d30d7d1c"],['__file',"src/components/widgets/widgetList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d30d7d1c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d30d7d1c', __exports__)) {
    api.reload('d30d7d1c', __exports__)
  }
  
}


export default __exports__